import get from 'just-safe-get'
import createFormModule from '../../utils/createFormModule'
import {
  SET_EMAIL,
  SET_PASSWORD,
  SET_WORKSPACE
} from './types'

const formModule = createFormModule({ resourcesPath: '/auth' })

export const state = {
  ...formModule.state,
  form: {
    email: '',
    password: '',
    workspace: ''
  }
}

export const mutations = {
  ...formModule.mutations,
  [SET_EMAIL] (state, value) {
    state.form.email = value
  },
  [SET_PASSWORD] (state, value) {
    state.form.password = value
  },
  [SET_WORKSPACE] (state, value) {
    state.form.workspace = value
  }
}

export const actions = {
  ...formModule.actions,
  setEmail ({ commit }, value) {
    commit(SET_EMAIL, value)
  },
  setPassword ({ commit }, value) {
    commit(SET_PASSWORD, value)
  },
  setWorkspace ({ commit }, value) {
    commit(SET_WORKSPACE, value)
  },
  customCreate ({ dispatch }) {
    return dispatch('create')
      .then(response => {
        if (response && get(response, 'data.authToken')) {
          dispatch('setAuthToken', response.data.authToken, { root: true })
        }
      })
  },
  reset ({ commit }) {
    commit(SET_WORKSPACE, '')
    commit(SET_EMAIL, '')
    commit(SET_PASSWORD, '')
  }
}

export const getters = {
  ...formModule.getters
}

export default {
  namespaced: true,
  state,
  mutations,
  actions,
  getters
}



// WEBPACK FOOTER //
// ./src/store/modules/auth/signInForm.js